var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0102539 50C0.0102539 53.3137 2.69655 56 6.01025 56H48.4602C51.774 56 54.4603 53.3137 54.4603 50V16.52L0.0102539 16.53V50Z",
    fill: "#C692FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9901 7.52002L2.30005 12.52C1.59768 12.9243 1.01488 13.5074 0.6109 14.21C0.20692 14.9126 -0.00383694 15.7096 5.28843e-05 16.52C0.000809008 17.3396 0.198291 18.147 0.5759 18.8743C0.953509 19.6017 1.50021 20.2278 2.17005 20.7L25.5601 37.16C26.0477 37.5071 26.6315 37.6936 27.2301 37.6936C27.8286 37.6936 28.4124 37.5071 28.9001 37.16L52.2901 20.71C52.9599 20.2378 53.5066 19.6117 53.8842 18.8843C54.2618 18.157 54.4593 17.3496 54.4601 16.53C54.4639 15.7196 54.2532 14.9226 53.8492 14.22C53.4452 13.5174 52.8624 12.9343 52.1601 12.53L43.5101 7.53002L10.9901 7.52002Z",
    fill: "#8139D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33012 0C8.9429 0 8.57154 0.153821 8.29774 0.427624C8.02394 0.701427 7.87012 1.07278 7.87012 1.46V24.72L25.5601 37.16C26.0478 37.5071 26.6315 37.6936 27.2301 37.6936C27.8287 37.6936 28.4124 37.5071 28.9001 37.16L46.5801 24.72V1.46C46.5801 1.07451 46.4277 0.704661 46.156 0.431144C45.8844 0.157626 45.5156 0.00264034 45.1301 0H9.33012Z",
    fill: "#9DD8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferBusiness);
export default __webpack_public_path__ + "static/media/refer_business.76637d949f48dfa5cb5daea34f852118.svg";
export { ForwardRef as ReactComponent };